import React, { Component } from 'react';
import { Button, Label, Icon } from 'semantic-ui-react';
import {observer} from 'mobx-react';
import eb from '../utils/EventBus';

class Search extends Component {

  constructor(props){
    super(props);
    this.state = {
      val: ''
    }
  }
  
  update = (val) => {
    if (val === '') {
      this.emitSearchMsg()
    }
    this.setState({
      val
    });
  }

  emitSearchMsg = () => {
    const route = window.location.href.replace(window.location.origin, '').replace('/', '');
    eb.emit(`search-${route}`, this.state.val);
  }


  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.emitSearchMsg()
    }
  }

  render() {
    console.log('here')
    return (
      <section className="search-bar">
				<input type="text" className="search-input" 
          placeholder="Search for anything ..."
          value={this.state.val}
          onChange={ ({target}) => this.update(target.value) } 
          onKeyPress={this._handleKeyPress} />

          <i className="fa fa-search" aria-hidden="true" onClick={this.emitSearchMsg}/>
      	
      	<Button as='div' labelPosition='left'>
	    </Button>
      </section>
    );
  }
}

export default observer(Search);


// WEBPACK FOOTER //
// ./src/components/search.js